<template>
    <div class="w-full flex flex-col items-center justify-center text-center px-8 py-16">
        <div class="w-16 h-16 rounded-full bg-blueGray-50 flex items-center justify-center mb-4">
            <i :class="icon" class="text-2xl text-blueGray-300"></i>
        </div>
        <p class="text-sm font-semibold text-blueGray-500">
            <slot>{{ title }}</slot>
        </p>
        <p class="text-xs text-blueGray-400 mt-2">
            {{ message }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            default: "fa fa-inbox"
        },
        title: {
            type: String,
            default: "Nothing here yet"
        },
        // Nothing currently overrides this via props or slot, but callers can adopt
        // a more specific hint per view going forward (e.g. "No disputes filed yet").
        message: {
            type: String,
            default: "There's no data to show for this view right now."
        }
    }
}
</script>
